import { render } from "./CensorLaws.vue?vue&type=template&id=7c141548&scoped=true"
import script from "./CensorLaws.vue?vue&type=script&lang=js"
export * from "./CensorLaws.vue?vue&type=script&lang=js"

import "./CensorLaws.vue?vue&type=style&index=0&id=7c141548&scoped=true&lang=css"
import "./CensorLaws.vue?vue&type=style&index=1&id=7c141548&lang=css"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c141548"]])

export default __exports__